<ng-container *ngIf="indicators.loadingSettingsAndTemplate">
  <div class="team-profile" id="profile">
    <checkin-skeleton></checkin-skeleton>
  </div>
</ng-container>

<ng-container *ngIf="!indicators.loadingSettingsAndTemplate">
  <feature-banner [cssClasses]="'sp-mb-20' + (checkInSettings.reflectionsEnabled ? ' sp-ml-30 sp-mr-98' : ' sp-mx-20')"></feature-banner>
  <no-checkins *ngIf="!checkInSettings.reflectionsEnabled" [includeCTAButton]="includeCtaButton" [teamId]="team.id"></no-checkins>

  <ng-container *ngIf="checkInSettings.reflectionsEnabled">
    <div class="sp-pb-20 reflection-nav">
      <div class="nav-left" [class.left-navigation-enabled]="isLeftNavigationEnabled" [class.compare-mode-enabled]="isCompareModeEnabled">
        <expand-collapse-buttons (statusChange)="toggleExpandState($event)"></expand-collapse-buttons>
      </div>
      <div class="nav-right" [class.left-navigation-enabled]="isLeftNavigationEnabled" [class.compare-mode-enabled]="isCompareModeEnabled">
        <cadence-pager
          class="cadence-pager"
          *ngIf="currCadenceStartDate"
          [cadenceStartDate]="currCadenceStartDate"
          [latestAvailableDate]="latestAvailableDate"
          [isComparing]="isCompareModeEnabled"
          (cadenceChange)="onCadenceChange($event)"></cadence-pager>
        <cadence-compare-button
          class="compare-button"
          [class.d-none]="!isCompareModeAvailable"
          [isComparing]="isCompareModeEnabled"
          (statusChange)="toggleCompareMode($event)"></cadence-compare-button>
      </div>
    </div>

    <div class="team-reflection" [class.left-navigation-enabled]="isLeftNavigationEnabled" [class.compare-mode-enabled]="isCompareModeEnabled">
      <reflection-overview
        [isCompareModeEnabled]="isCompareModeEnabled"
        [filters]="filters"
        [isNotesSettingEnabled]="checkInTemplate.notesEnabled"
        (selectedFilterChange)="onSelectedFilterChange($event)"></reflection-overview>
      <gh-indicator [(ghValue)]="indicators.loadingIndicator" [ghMessage]="'loading' | localize"></gh-indicator>
      <reflection-orchestrator
        *ngIf="currReflections && !indicators.loadingIndicator"
        [team]="team"
        [teams]="teams"
        [currReflections]="currReflections"
        [prevReflections]="prevReflections"
        [filter]="filter"
        [compareMode]="isCompareModeEnabled"
        [currCadenceStartDate]="currCadenceStartDate"
        [pageSize]="pageSize"
        [expanedPanelId]="panelExpandedId"
        [currentPage]="currentPage"
        [prevCadenceStartDate]="prevCadenceStartDate"
        [checkInTemplate]="checkInTemplate"
        [expandCollapseAll]="expandCollapseAll.asObservable()"
        [assignees]="assignees"
        (reflectionEdit)="onReflectionEdit($event)"
        (pageChange)="onPageChange($event)"
        (okrLinkClick)="okrLinkClicked($event)"
        (reflectionPublish)="onReflectionPublish($event)"></reflection-orchestrator>
    </div>
  </ng-container>
</ng-container>
